import { render } from "./BookingBrandedRedirect.vue?vue&type=template&id=5c6c6360&ts=true"
import script from "./BookingBrandedRedirect.vue?vue&type=script&lang=ts"
export * from "./BookingBrandedRedirect.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__